'use client';

import { TrackedCTA } from '@/components/TrackedCTA';
import { accountUrl } from '@/lib/config';
import type { PageContext } from '@/lib/cta-tracking';

const HOME_PAGE_CONTEXT: PageContext = {
    page_type: 'home',
    page_name: 'Home',
    page_slug: 'home',
    page_category: 'marketing',
};

/**
 * Tracked Hero CTA buttons for the home page.
 * Replace the static <Link> CTAs in the Hero section with this component.
 */
export function TrackedHeroCTAs() {
    return (
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-4">
            <TrackedCTA
                href={`${accountUrl}/app/auth/register`}
                pageContext={HOME_PAGE_CONTEXT}
                ctaContext={{
                    cta_name: 'create_event',
                    cta_label: '🎉 Create Your Event',
                    cta_position: 'hero',
                    cta_variant: 'primary',
                }}
                className="w-full rounded-xl bg-[#FFC933] px-6 py-3 font-semibold text-[#2B0A4A] shadow-lg shadow-[#FFC933]/25 transition-all hover:bg-[#FF8A3D] hover:shadow-[#FF8A3D]/25 sm:w-auto lg:px-8 lg:py-4"
            >
                🎉 Create Your Event
            </TrackedCTA>
            <a
                href="#how-it-works"
                className="w-full rounded-xl border-2 border-[#2B0A4A] bg-transparent px-6 py-3 font-semibold text-[#2B0A4A] transition-all hover:bg-[#2B0A4A] hover:text-white sm:w-auto lg:px-8 lg:py-4"
            >
                See How It Works
            </a>
        </div>
    );
}
